import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for session cookies
});

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.login_required) {
      // Redirect to login is handled by MSAL
      console.log('Authentication required');
    }
    return Promise.reject(error);
  }
);

// Agent Dashboard API
export const getAgents = async (online = null) => {
  const params = online !== null ? `?online=${online}` : '';
  const response = await api.get(`/agents${params}`);
  return response.data;
};

export const getAgentsCurrentStatus = async () => {
  const response = await api.get('/agents/current-status');
  return response.data;
};

export const getAgentDashboard = async (userEmail = '') => {
  const params = userEmail ? `?user_email=${encodeURIComponent(userEmail)}` : '';
  const response = await api.get(`/agents/dashboard${params}`);
  return response.data;
};

export const getAgentActivity = async (agentId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await api.get(`/agents/${agentId}/activity${queryString ? '?' + queryString : ''}`);
  return response.data;
};

export const getCallDetails = async (callId) => {
  const response = await api.get(`/calls/${callId}`);
  return response.data;
};

export const getCallRecordingUrl = (callId, userEmail) =>
  `${API_BASE_URL}/calls/${callId}/recording?user_email=${encodeURIComponent(userEmail || '')}`;

export const getChatDetails = async (chatId) => {
  const response = await api.get(`/chats/${chatId}`);
  return response.data;
};

// Agent Status Change API
export const setAgentStatus = async (agentId, status) => {
  const response = await api.post(`/agents/${agentId}/set-status`, { status });
  return response.data;
};

// Operation Hours API
export const getOperationHours = async () => {
  const response = await api.get('/operation-hours');
  return response.data;
};

export default api;

